// eslint-disable-next-line no-useless-escape
export const PHONE_REGEX = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]{5,15}$/

type Timezone = 'Europe/Vienna'
export const defaultTimezone: Timezone = 'Europe/Vienna'

export const defaultMinimumItemValue = 50
